<div class="logoContainer">
  <img
    src="{{ user?.MERCHANT_LOGO }}"
    alt="{{ user?.MERCHANT_NAME }}"
    id="_branding_logo"
    title="{{ user?.MERCHANT_NAME }}"
    *ngIf="user?.MERCHANT_LOGO"
  />
  <h1 *ngIf="!user?.MERCHANT_LOGO && user?.MERCHANT_NAME" id="_branding_name">
    {{ user?.MERCHANT_NAME }}
  </h1>
</div>
